"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawaySection = void 0;
const CreatorGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/CreatorGiveawaySection");
const ViewerGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/ViewerGiveawaySection");
const useGiveawaySection_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection");
const useCreatorDataApi_1 = require("root/src/client/logic/api/hooks/useCreatorDataApi");
const useInterval_1 = require("root/src/client/v2/common/hooks/useInterval");
const giveaways_constants_1 = require("root/src/shared/giveaways/giveaways.constants");
const react_1 = require("react");
const useIsActiveTab_1 = require("root/src/client/v2/common/hooks/useIsActiveTab");
const useIsWindowFocused_1 = require("root/src/client/v2/common/hooks/useIsWindowFocused");
const useCreatorData_1 = require("root/src/client/logic/api/hooks/useCreatorData");
const LoadingCircles_1 = __importDefault(require("root/src/client/web/base/LoadingCircles"));
const rewards_api_contract_1 = require("@daredrop-com/rewards-api-contract");
const useGiveawayApi_1 = require("root/src/client/web/giveaway/hooks/useGiveawayApi");
const GiveawaySection = () => {
    const { classes, isCreatorProfile, giveaway, isLoading, } = (0, useGiveawaySection_1.useGiveawaySection)();
    const creatorDataApi = (0, useCreatorDataApi_1.useCreatorDataApi)();
    const giveawayApi = (0, useGiveawayApi_1.useGiveawayApi)();
    const creatorData = (0, useCreatorData_1.useCreatorData)();
    const isBetaTester = Boolean(creatorData === null || creatorData === void 0 ? void 0 : creatorData.isBetaTester);
    const isActiveTab = (0, useIsActiveTab_1.useIsActiveTab)();
    const isWindowFocused = (0, useIsWindowFocused_1.useIsWindowFocused)();
    (0, react_1.useEffect)(() => {
        if (isBetaTester && isActiveTab && isWindowFocused) {
            void Promise.allSettled([
                creatorDataApi.fetchGiveaways(),
                creatorDataApi.fetchRewards(),
                giveawayApi.fetchVouchers(rewards_api_contract_1.VoucherStatus.Available),
            ]);
        }
    }, [isBetaTester, isActiveTab, isWindowFocused]);
    (0, useInterval_1.useInterval)(() => {
        void creatorDataApi.fetchGiveaways();
    }, giveaways_constants_1.GIVEAWAY_POOLING_TIME_MS, {
        enabled: Boolean(giveaway),
    });
    if (isLoading) {
        return (<div className={classes.root}>
				<LoadingCircles_1.default width={150} height={150}/>
			</div>);
    }
    if (isCreatorProfile) {
        return <CreatorGiveawaySection_1.CreatorGiveawaySection />;
    }
    return <ViewerGiveawaySection_1.ViewerGiveawaySection />;
};
exports.GiveawaySection = GiveawaySection;
